import * as requestFromServer from "./UnregisteredStudentsCrud";
import { callTypes, unregisteredStudentSlice } from "./UnregisteredStudentsSlice";

const {actions} = unregisteredStudentSlice;

export const getUnregisteredStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getUnregisteredStudents(queryParams)
    .then(response => {
      dispatch(actions.unregisteredStudentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllUnregisteredStudents = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllUnregisteredStudents(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getUnregisteredStudent = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewUnregisteredStudent()
    .then(response => {
      dispatch(actions.unregisteredStudentFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getUnregisteredStudent(id)
    .then(response => {
      dispatch(actions.unregisteredStudentFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveUnregisteredStudent = student => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveUnregisteredStudent(student)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteUnregisteredStudents = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteUnregisteredStudents(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanUnregisteredStudentsState = () => dispatch => {
  dispatch(actions.unregisteredStudentsStateCleaned());
}